module.exports = __webpack_public_path__ + "img/iq.e039ae4e.svg";